import { useEffect, useState } from 'react';

import { Point3D } from '@paragon/geometry-library';

import { threeJsDom } from '../util/events/ThreeJSDom';
import { GlobalThreeJSDomObjectEvent } from '../util/events/types';

/**
 * Calculates the current position of the mouse in the current scene in world coordinates.
 *
 * Note that this will force a re-render of your component on every mousemove tick. Use with caution.
 */
export function useMousePositionInScene(active = true): Point3D | null {
  const [mousePosition, setMousePosition] = useState<Point3D | null>(null);

  function onMouseMove(event: GlobalThreeJSDomObjectEvent) {
    setMousePosition(Point3D.fromObject(event.eventPosition.worldPosition));
  }

  function onMouseLeave() {
    setMousePosition(null);
  }

  useEffect(() => {
    if (!active) return;

    threeJsDom.addGlobalListener('mousemove', onMouseMove);
    threeJsDom.addGlobalListener('mouseleave', onMouseLeave);

    return () => {
      threeJsDom.removeGlobalListener('mousemove', onMouseMove);
      threeJsDom.removeGlobalListener('mouseleave', onMouseLeave);
    };
  }, [active]);

  return mousePosition;
}
